import { combineReducers } from 'redux';
import localeReducer from './localeReducer';
import qcSearchReducer from './qcSearchReducer';
import sdsSearchReducer from './sdsSearchReducer';
import wwbReducer from './wwbReducer';

export default combineReducers({
  localeReducer: localeReducer,
  qcSearchReducer: qcSearchReducer,
  sdsSearchReducer: sdsSearchReducer,
  wwbReducer: wwbReducer
});
